import { ComponentRef, Injectable, OnDestroy, ViewContainerRef } from '@angular/core';
import { NavigationCancel, NavigationError, Router } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { RouterService } from 'src/app/shared/shared-base/amg-ui/router.service';
import { Logger } from 'src/app/shared/tcs-logging/logger';
import { Subject } from 'rxjs';
import { MatLegacyProgressBar as MatProgressBar } from '@angular/material/legacy-progress-bar';
import { PageViewService } from './pageview.service';

@Injectable({
  providedIn: 'root',
})
export class RouterLoadingService implements OnDestroy {
  private static initialized = false;
  private _onDestroy$ = new Subject();
  private _loadingCmp: ComponentRef<MatProgressBar>;
  constructor(
    private _routerService: RouterService,
    private _router: Router,
    private _logger: Logger,
    private _pageview: PageViewService,
  ) {}

  public init(ref: ViewContainerRef) {
    if (!RouterLoadingService.initialized) {
      this._loadingCmp = ref.createComponent(MatProgressBar, {
        injector: ref.injector,
        index: 0,
      });
      const vcr = this._loadingCmp.injector.get(ViewContainerRef);
      this._loadingCmp.instance.mode = 'indeterminate';
      this._loadingCmp.instance.color = 'accent';

      this._routerService.navigationStart$.pipe(takeUntil(this._onDestroy$)).subscribe(() => {
        this.loading(vcr);
      });
      this._router.events
        .pipe(
          filter((e) => {
            return e instanceof NavigationCancel || e instanceof NavigationError;
          }),
          takeUntil(this._onDestroy$),
        )
        .subscribe(() => {
          this.loaded(vcr);
        });
      this._pageview.pageviews$.pipe(takeUntil(this._onDestroy$)).subscribe(() => {
        this.loaded(vcr);
      });

      RouterLoadingService.initialized = true;
    } else {
      this._logger.warning('RouterLoadingService has already been initialized');
    }
  }

  public loading(vcr: ViewContainerRef) {
    vcr.element.nativeElement.style = 'z-index:100;position:absolute;top:0';
  }

  public loaded(vcr: ViewContainerRef) {
    vcr.element.nativeElement.style = 'display:none';
  }

  public ngOnDestroy(): void {
    this._onDestroy$.next(null);
    this._onDestroy$.complete();
    this._loadingCmp.destroy();
  }
}
